import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import he from "he";
import { assetUrl, bpVars } from "../../functions/themeAssets";
import { STAGE_PATHS } from "../bigpicture/gameApi";
import { bannerSrc, Loader, StageHeader, SubmitButton } from "../bigpicture/components";
import { formatClock, useStage, useStopwatch } from "../bigpicture/useStage";
import "../styles/bp-simple.css";

const norm = (v) => String(v || "").trim().toLowerCase();

const GREEN = { backgroundColor: "green", color: "white", border: "2px solid darkgreen" };
const RED = { backgroundColor: "red", color: "white", border: "2px solid darkred" };

/** Challenge 2 — Think Simple: type the answer for every question / picture (think-simple.php). */
export default function ThinkSimple() {
  const navigate = useNavigate();
  const { game, finish } = useStage(2);
  const [values, setValues] = useState([]);
  const [saving, setSaving] = useState(false);
  const seconds = useStopwatch(game?.state?.elapsed, !!game);

  const pairs = useMemo(() => game?.content?.pairs || [], [game]);
  const solved = useMemo(() => pairs.map((p, i) => norm(values[i]) !== "" && norm(values[i]) === norm(p.item2)), [pairs, values]);
  const points = (game?.state?.score || 0) + solved.filter(Boolean).length;

  if (!game) return <Loader />;
  const theme = game.theme;

  const onChange = (i, raw) => {
    if (solved[i]) return; // a right answer locks the box
    const value = raw.replace(/^\s+/, "");
    setValues((prev) => {
      const next = [...prev];
      next[i] = value;
      return next;
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;
    setSaving(true);
    const result = await finish({ answers: pairs.map((_, i) => String(values[i] || "").trim()) });
    if (!result) {
      setSaving(false);
      return;
    }
    navigate(STAGE_PATHS[result.stage], { replace: true });
  };

  return (
    <div className="bp-simple" style={bpVars(theme)}>
      <StageHeader clock={formatClock(seconds)} points={points} src={bannerSrc(theme, 2)} alt="Challenge 2" />

      <div className="tf-wrapper">
        <div className="tf-card">
          <div className="tf-instructions">
            <p className="tf-instructions-text">{he.decode(String(theme.landing_page_title2 || ""))}</p>
          </div>

          <form onSubmit={onSubmit}>
            <div className="ts-questions-grid">
              {pairs.map((pair, i) => {
                const typed = norm(values[i]) !== "";
                const style = solved[i] ? GREEN : typed ? RED : undefined;
                return (
                  <div className="ts-question-card" key={i}>
                    <div className="ts-question-prompt">
                      {pair.isImage ? (
                        <img src={assetUrl(pair.item1)} alt="question" />
                      ) : (
                        <h3>{he.decode(String(pair.item1 || ""))}</h3>
                      )}
                    </div>
                    <input
                      type="text"
                      className="ts-answer-input"
                      id={`ans${i}`}
                      name={`ans${i}`}
                      placeholder="Type answer..."
                      value={values[i] || ""}
                      readOnly={solved[i]}
                      style={solved[i] ? { ...style, pointerEvents: "none" } : style}
                      onChange={(e) => onChange(i, e.target.value)}
                      required
                    />
                  </div>
                );
              })}
            </div>

            <SubmitButton disabled={saving} />
          </form>
        </div>
      </div>
    </div>
  );
}
